import { Container } from "@remo-co/ui-core/src/components/Container";
import { useVirtualBackground } from "modules/audioVideo/hooks/useVirtualBackground";
import { VideoTile } from "../VideoTile";
import { useStyles } from "./styles";

export const AudioVideoPreview = () => {
  const styles = useStyles();
  const { virtualBackgroundSupported } = useVirtualBackground();

  return (
    <Container
      fullWidth
      data-testid="audio-video-preview"
      className={styles.container}
    >
      <VideoTile
        showToggles
        showSettings
        showBlur={virtualBackgroundSupported}
      />
    </Container>
  );
};
